
import on_domready from "domready"

import widgets_onload from "./widgets/onLoad"
import buttons from "./buttons/onLoad"
import modal from "./modal/onLoad"
import main_navbar from "./main_navbar/onLoad"
import main_navbar_menu from "./main_navbar_menu/onLoad"
import layout from "./layout/onLoad"
import main_footer from "./main_footer/index"
import js_link_modal from "./js_link_modal"
import select2 from "./select2/index"

const onLoad = () => {
  on_domready(() => {
    widgets_onload()
    buttons.onLoad()
    modal.onLoad()
    main_navbar.onLoad()
    main_navbar_menu.onLoad()
    layout.onLoad()
    main_footer.onLoad()
    js_link_modal.onLoad()
    select2.onLoad()
  })
}

export default onLoad
